import {
  IMG_LEVEL_1_FORGROUND,
  IMG_LEVEL_1_BACKGROUND_1,
  IMG_LEVEL_1_BACKGROUND_2,
  ENEMY_FACES_LEFT,
} from '../constants';

export default {
  forground: IMG_LEVEL_1_FORGROUND,
  background1: IMG_LEVEL_1_BACKGROUND_1,
  background2: IMG_LEVEL_1_BACKGROUND_2,
  objects: [
    [0, 0, 1350, 1315],
    [0, 2900, 2000, 100],
    [1220, 0, 775, 995],
    [0, 1260, 955, 800],
    [0, 1639, 1668, 165],
    [1949, 1800, 600, 70],
    [2213, 1825, 50, 620],
    [2189, 2447, 60, 275],
    [2170, 2710, 87, 270],
    [1536, 2958, 638, 49],
    [1455, 1826, 85, 1145],
    [2235, 2723, 742, 315],
    [2948, 2991, 3310, 62],
    [2249, 2319, 830, 132],
    [3818, 1288, 327, 130],
    [2788, 1807, 335, 704],
    [2543, 1747, 342, 135],
    [2486, 1159, 521, 386],
    [5286, 0, 200, 3000],
    [4970, 2192, 325, 50],
    [3396, 1806, 932, 664],
    [3775, 2726, 840, 111],
    [3353, 1683, 1270, 233],
    [4208, 1800, 325, 332],
    [3982, 2807, 632, 192],
    [4977, 2468, 400, 72],
  ],
  actionItems: [
    {
      type: 'vertical elevator',
      x: 3181,
      y: 1806,
      w: 196,
      h: 36,
      speed: 4,
      startY: 1806,
      maxY: 2850,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      type: 'vertical elevator',
      x: 4660,
      y: 1688,
      w: 196,
      h: 36,
      speed: 3,
      startY: 1688,
      maxY: 2720,
      spriteCount: 0,
      maxSpriteCount: 3,
      img: 'ELEVATOR',
    },
    {
      status: true,
      key: 'ABA',
      type: 'laser',
      x: 2622,
      y: 2470,
      w: 96,
      h: 288,
      spriteCount: 0,
      maxSpriteCount: 8,
      beamX: 52,
      beamY: 80,
      beamW: 48,
      img: 'LASER',
    },
    {
      type: 'DOOR',
      x: 2280,
      y: 2527,
      w: 192,
      h: 192,
      spriteCount: 0,
      maxSpriteCount: 7,
      img: 'DOOR',
    },
  ],
  messages: [],
  explosions: [],
  shots: [], // projectiles
  hits: [],
  items: [ // messages as items
    {
      type: 'COMPUTER',
      key: 'ABA',
      x: 5170,
      y: 2790,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'LEVEL',
      mode: 'MODE_SC2',
      next: 'sc2',
      startX: 210,
      startY: 700,
      x: 2282,
      y: 2527,
      w: 192,
      h: 192,
      status: true,
    },
    {
      type: 'MESSAGE',
      x: 1480,
      y: 1480,
      w: 200,
      h: 200,
      status: true,
      message: 'PRESS H FOR HELP',
    },
    {
      type: 'MEDICIN',
      x: 3785,
      y: 2885,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 5120,
      y: 2350,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 2751,
      y: 1667,
      w: 75,
      h: 75,
      status: true,
    },
    {
      type: 'AMMO',
      x: 3051,
      y: 1667,
      w: 75,
      h: 75,
      status: true,
    },
  ],
  enemies: [
    {
      type: 'TYPE_1',
      x: 4825,
      y: 2810,
      status: true,
      hp: 2,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 4734,
      y: 2827,
      status: true,
      hp: 2,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_1',
      x: 2430,
      y: 1688,
      status: true,
      hp: 4,
      w: 99,
      h: 111,
      jumping: false,
      spriteCount: 0,
      speed: -3,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      x: 3320,
      y: 2810,
      status: true,
      hp: 2,
      shotInterval: 0,
      w: 142,
      h: 127,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
    {
      type: 'TYPE_2',
      status: true,
      x: 4225,
      y: 1525,
      hp: 2,
      w: 142,
      h: 127,
      shotInterval: 0,
      jumping: false,
      spriteCount: 0,
      speed: -4,
      grounded: false,
      velX: 0,
      velY: 10,
      state: 'LEFT',
      faces: ENEMY_FACES_LEFT,
    },
  ],
  areas: [],
};
